import axios from 'axios';
import { baseUrl } from '@/config';

export default {
  /**
   * 시설장비 - RTU 리스트를 조회한다.
   * @author Song
   * @return {Object} [response 객체]
   */
  getRtuList(params) {
    return axios.post(`${baseUrl}/settings/device-registration-fms/get-rtu-list.do`, params);
  },
  /**
   * 시설장비 - RTU 리스트를 수정한다.
   * @author Song
   * @return {Object} [response 객체]
   */
  updateRtuList(params) {
    return axios.post(`${baseUrl}/settings/device-registration-fms/update-rtu-list.do`, params);
  },
  /**
   * 시설장비 - RTU 리스트를 삭제한다.
   * @author Song
   * @return {Object} [response 객체]
   */
  deleteFacilityList(params) {
    return axios.post(`${baseUrl}/settings/device-registration-fms/delete-facility-list.do`, params);
  },
  /**
   * 시설장비 - 관리대상 리스트를 조회한다.
   * @author Song
   * @return {Object} [response 객체]
   */
  getFacilityList(params) {
    return axios.post(`${baseUrl}/settings/device-registration-fms/get-facility-list.do`, params);
  },
  /**
   * 시설장비 - 관리대상(센서) 및 RTU 정보를 수정한다.
   * @author Song
   * @return {Object} [response 객체]
   */
  updateFacilityList(params) {
    return axios.post(`${baseUrl}/settings/device-registration-fms/update-facility-list.do`, params);
  },
  /**
   * 시설장비 - 관리대상(센서) 수동 등록
   * @author Song
   * @return {Object} [response 객체]
   */
  setFacilityDevice(params) {
    return axios.post(`${baseUrl}/settings/device-registration-fms/set-facility-list.do`, params);
  },
  /**
   * 시설장비 - 최근 3일 이내에 등록한 fms 장비 카운트를 조회한다.
   * @author Song
   * @return {Object} [response 객체]
   */
  getRecentRegisteredFmsCount() {
    return axios.get(`${baseUrl}/settings/device-registration-fms/get-recent-registered-fms-count.do`);
  },
};



// WEBPACK FOOTER //
// ./src/api/settings/common/device-registration-fms.js